// React, Packages
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { StripeProvider } from "react-stripe-elements";

// redux
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import thunkMiddleware from "redux-thunk";
import multi from "redux-multi";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { PersistGate } from "redux-persist/integration/react";
import createEncryptor from "redux-persist-transform-encrypt";
import { HelmetProvider } from "react-helmet-async";

// reducers (redux)
import rootReducer from "./redux/reducers";
import Routes from "./Routes";

// Font Awesome
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAngleRight,
  faAlignCenter,
  faAlignLeft,
  faAlignRight,
  faBars,
  faUser,
  faMapSigns,
  faBusinessTime,
  faEdit,
  faTag,
  faTrophy,
  faCommentAlt,
  faCircle,
  faEllipsisV,
  faBell,
  faSearch,
  faArrowLeft,
  faTimesCircle,
  faChartLine,
  faQuestionCircle,
  faUserShield,
  faUserPlus,
  faStar,
  faChevronLeft,
  faChevronRight,
  faUserCircle,
  faPlusCircle,
  faWifi,
  faDollarSign,
  faHandHoldingUsd,
  faPrint,
  faMoneyCheckAlt,
  faShoppingBasket,
  faHandshake,
  faPlay,
  faTruck,
  faFileInvoice,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faAngleRight,
  faBars,
  faAlignCenter,
  faAlignLeft,
  faAlignRight,
  faBusinessTime,
  faUser,
  faMapSigns,
  faEdit,
  faTag,
  faTrophy,
  faCommentAlt,
  faCircle,
  faEllipsisV,
  faBell,
  faQuestionCircle,
  faSearch,
  faChartLine,
  faTimesCircle,
  faUserShield,
  faUserPlus,
  faChevronLeft,
  faChevronRight,
  faStar,
  faArrowLeft,
  faUserCircle,
  faPlusCircle,
  faWifi,
  faDollarSign,
  faHandHoldingUsd,
  faPrint,
  faMoneyCheckAlt,
  faShoppingBasket,
  faHandshake,
  faPlay,
  faFileInvoice,
  faPaperPlane
);

const encryptor = createEncryptor({
  secretKey: "my-super-secret-key",
  onError: function (error) {
    // Handle the error.
    console.error(error);
  },
});

// web.mobile360.io
// mobile360.io
// www.mobile360.io

// this is how redux know to use reducers to set state
const persistConfig = {
  transforms: process.env.NODE_ENV !== "prod" ? [] : [encryptor],
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// REDUX DEV TOOL for dev
const composeEnhancers =
  typeof window === "object" &&
  process.env.NODE_ENV !== "prod" &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

/**
 * @desc creates redux store for app
 * @param reducer,
 * @return store -
 */
export const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(thunkMiddleware, multi))
);

const persistor = persistStore(store);

class App extends React.Component {
  constructor() {
    super();
    this.state = { stripe: null };
  }
  componentDidMount() {
    if (window.Stripe) {
      this.setState({ stripe: window.Stripe(__STRIPE_API_KEY__) });
    } else {
      document.querySelector("#stripe-js").addEventListener("load", () => {
        // Create Stripe instance once Stripe.js loads
        this.setState({ stripe: window.Stripe(__STRIPE_API_KEY__) });
      });
    }
  }

  render() {
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <StripeProvider stripe={this.state.stripe}>
              <HelmetProvider>
                <Routes />
              </HelmetProvider>
            </StripeProvider>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    );
  }
}

window.onload = () => {
  ReactDOM.render(<App />, document.getElementById("app"));
};
